import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { LEVEL, ModalData } from '@tc-core/model/it/codegen/ui/framework/modal-data';
import { TC } from '@tc-core/util';
import { ConfigLoader, EventManager, UserJourneyManager } from '@tc-core/util/framework';
import { CommonHelper } from '@tc-core/util/helpers';
import { DateFormatter } from '@tc-core/util/system';
import { ChipInputComponent } from '@tc/chip-input';
import { ModalService } from '@tc/modal/modal.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TCO } from '../../../constants';
import { ReservationSearchCriteria } from '../../../models/criteria/reservation-search-criteria';
import { SortDirection } from '../../../models/helper/sort-direction';
import { ShowSavedCriteriaModalComponent } from '../../reservation-management/show-saved-criteria-modal/show-saved-criteria-modal.component';
import { GenReservationManagementService } from '../../../services/backend-consumers/reservation-management-services/gen-reservation-management.service';
import { ChipHandlerService } from '../../../services/helpers/chip-handler.service';
import { RootService } from '../../../services/util/core-services/root.service';
import { ActionHandlerService } from '../../../services/util/framework/action-handler-service.service';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';
import { DMCQueryParamsService } from '../../../services/util/framework/dmc-query-params.service';
var GenReservationSearchCriteriaComponent = /** @class */ (function () {
    function GenReservationSearchCriteriaComponent(configLoader, dataStoreService, em, queryParamService, rootService, chipHandler, commonHelper, userJourneyManager, actionHandlerService, modalService, dateFormatter, genReservationManagementService) {
        this.configLoader = configLoader;
        this.dataStoreService = dataStoreService;
        this.em = em;
        this.queryParamService = queryParamService;
        this.rootService = rootService;
        this.chipHandler = chipHandler;
        this.commonHelper = commonHelper;
        this.userJourneyManager = userJourneyManager;
        this.actionHandlerService = actionHandlerService;
        this.modalService = modalService;
        this.dateFormatter = dateFormatter;
        this.genReservationManagementService = genReservationManagementService;
        this.isInsideForm = false;
        this.isSearchBarStyleNotAvailable = false;
        this.searchTrigger = new EventEmitter();
        this.searchCriteria = new EventEmitter();
        this.availableChips = [];
        this.isDataLoaded = true;
        this.isChipsInit = false;
        this.isChipListDisplay = false;
        this.displayChipsArr = [];
        this.isFocus = false;
        this.placeHolderText = 'Search Generic Services';
        this.persistentQParams = [];
        this.persistentQParamMap = new Map();
        this.persistentChipsArr = [];
        this.isTriggerSearch = true;
        this.journey = null;
        this.systemDefinedCriteriaList = [];
        this.userDefinedCriteriaList = [];
        this.selectedChipsObsv = new Subscription();
        this.selectedFieldsObsv = new Subscription();
        this.chipValueUpdateSub = new Subscription();
        this.relatedChipsObsv = new Subscription();
        this.relatedChipsProcessObsv = new Subscription();
        this.criteriaUpdateSubscription = new Subscription();
        this.deletedChipObsv = new Subscription();
        this.selectedChips = [];
        this.chipHandlerSubject = new Subscription();
        this.SERVICE_TYPE = 'GEN';
        this.PRODUCT_CODE = '';
    }
    GenReservationSearchCriteriaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.chipInputService = this.genericQueueSearchChipInput.criteriaInputService;
        this.tPagination = this.configLoader.configurations.get(TCO.CONF.CONF_PAGINATION_CONFIG)['GEN_RESERVATION_SEARCH'];
        // reset the search results
        this.dataStoreService.set(DataKey.genReservationSearchCriteria, null, true);
        this.dataStoreService.set(DataKey.genReservationSearchResultsFromService, null, true);
        this.handleQuickActions();
        this.userJourneyManager.journey.subscribe(function (journey) {
            if (journey && JSON.stringify(journey) !== JSON.stringify({})) {
                _this.journey = journey.id;
            }
        });
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'SHOW_SAVED_CRITERIA').subscribe(function (e) {
            _this.onShowSavedCriteriaClick();
        });
        this.getUserDefinedCriteriaList();
        this.getSystemDefinedCriteriaList();
        if (!this.isInsideForm) {
            this.getQueryParams();
            if (!this.isChipsInit) {
                this.initSearchCriteriaChips(); // load everything from start
            }
        }
        this.getGenReservationSearchObserver();
        this.errorObserver();
        // this.selectedChipsUpdate();
        this.shortCutObserver();
        this.handleInterRelatedChips();
        // this.notifyChipDelete();
        // this.shortCutObserver();
    };
    GenReservationSearchCriteriaComponent.prototype.getQueryParams = function () {
        var queryParams = [];
        queryParams = this.queryParamService.getQueryParamsArray(new ReservationSearchCriteria());
        this.genReservationSearchCriteria = this.rootService.loadDataFromLocalStorage(queryParams, new ReservationSearchCriteria(), TCO.AppData.GEN_RESERVATION_SEARCH_CRITERIA);
        this.genReservationSearchCriteria.serviceType = this.SERVICE_TYPE;
        if (!this.genReservationSearchCriteria.productCode) {
            this.genReservationSearchCriteria.productCode = this.PRODUCT_CODE;
        }
        if (this.genReservationSearchCriteria && !this.genReservationSearchCriteria.startDate) {
            this.genReservationSearchCriteria.startDate = new Date().toISOString().split('T')[0];
        }
        if (this.genReservationSearchCriteria && !this.genReservationSearchCriteria.endDate) {
            this.genReservationSearchCriteria.endDate = new Date(+new Date(this.genReservationSearchCriteria.startDate) + 172800000).toISOString().split('T')[0];
        }
        if (this.genReservationSearchCriteria) {
            this.persistentQParams = [];
            this.persistentQParams = this.queryParamService.getNotNullQueryParamsArray(this.genReservationSearchCriteria);
        }
    };
    GenReservationSearchCriteriaComponent.prototype.shortCutObserver = function () {
        var _this = this;
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'FOCUS_SEARCH_BAR').subscribe(function (e) {
            _this.isFocus = true;
        });
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'CLOSE_POPUPS').subscribe(function (e) {
            _this.isFocus = false;
        });
    };
    GenReservationSearchCriteriaComponent.prototype.onFocus = function (event) {
        this.isFocus = event;
    };
    GenReservationSearchCriteriaComponent.prototype.initSearchCriteriaChips = function () {
        var _this = this;
        this.isChipsInit = true;
        this.chipInputService.fullReset(); // fully reset chips
        this.chipHandler.chipsArr = [];
        // read chip config
        var criteriaChipConfigs = null;
        if (!this.isInsideForm) {
            var chipConfigs = this.configLoader.configurations.get(TCO.CONF.CONF_GEN_RESERVATION_SEARCH_CRITERIA_CHIP);
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        }
        else {
            var chipConfigs = this.configLoader.configurations.get(this.searchCriteriaChipConfig);
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        }
        if (criteriaChipConfigs.chips) {
            criteriaChipConfigs.chips.forEach(function (chip) {
                chip = _this.chipHandler.preProcessChips(chip, criteriaChipConfigs.permissionKeys.keys);
            });
        }
        var isDataLoaded = false;
        // isDataLoaded = true; //todo remove
        this.chipHandler.chipsSubject.subscribe(function (data) {
            if (data && JSON.stringify(data) !== JSON.stringify([]) && !isDataLoaded) {
                isDataLoaded = true;
                _this.availableChips = data;
                _this.chipHandler.chipsSubject.next(null);
                if (_this.chipHandlerSubject) {
                    _this.chipHandlerSubject.unsubscribe();
                }
                // set values to display chips
                _this.displayChipsArr = [];
                _this.displayChipsArr = _this.availableChips;
                _this.dataStoreService.set(DataKey.chips, _this.availableChips, true);
                _this.genReservationSearchCriteria.serviceType = _this.SERVICE_TYPE;
                if (_this.genReservationSearchCriteria && !_this.genReservationSearchCriteria.startDate) {
                    _this.genReservationSearchCriteria.startDate = new Date().toISOString().split('T')[0];
                }
                if (_this.genReservationSearchCriteria && !_this.genReservationSearchCriteria.endDate) {
                    _this.genReservationSearchCriteria.endDate = new Date(+new Date(_this.genReservationSearchCriteria.startDate) + 172800000)
                        .toISOString().split('T')[0];
                }
                _this.availableChips.forEach(function (chip) {
                    if (chip['criteriaId'] === 'RESOURCE_TYPE') {
                        chip['optionParams']['isInitialPresent'] = true;
                        if (chip['optionParams']['defValue'] && _this.genReservationSearchCriteria.productCode === _this.PRODUCT_CODE) {
                            _this.genReservationSearchCriteria.productCode = chip['optionParams']['defValue'];
                            var choice = chip['optionParams']['options']
                                .filter(function (option) { return option.code === chip['optionParams']['defValue']; });
                            chip['optionParams']['data'] = choice;
                        }
                        else if (_this.genReservationSearchCriteria.productCode === _this.PRODUCT_CODE) {
                            _this.genReservationSearchCriteria.productCode = undefined;
                        }
                    }
                });
                _this.chipInputService.init(_this.genReservationSearchCriteria, _this.availableChips, false, true);
                _this.isChipsInit = true;
                // implement chip persistance
                if (_this.persistentQParams && _this.persistentQParams.length > 0) {
                    // create a queryParamMap
                    for (var i = 0; i < _this.persistentQParams.length; i++) {
                        var qParam = _this.persistentQParams[i];
                        var qParamValue = _this.genReservationSearchCriteria[qParam];
                        if (qParam && qParamValue) {
                            _this.persistentQParamMap.set(qParam, qParamValue);
                        }
                    }
                    _this.persistentChipsArr = [];
                    // fill persistent chips
                    _this.availableChips.forEach(function (chip) {
                        var persistChip = Object.assign({}, chip);
                        persistChip.optionParams.data = [];
                        var isPersist = false;
                        if (chip.dataParams && chip.dataParams.length > 0) {
                            chip.dataParams.forEach(function (dataParam) {
                                if (_this.persistentQParamMap.has(dataParam.paramValue)) {
                                    isPersist = true;
                                    var dataObj = {
                                        key: dataParam.paramValue,
                                        value: _this.persistentQParamMap.get(dataParam.paramValue)
                                    };
                                    persistChip.optionParams.data.push(dataObj);
                                }
                            });
                        }
                        // push persist chips to an array
                        if (isPersist) {
                            _this.persistentChipsArr.push(persistChip);
                        }
                    });
                    // persist chips
                    if (_this.persistentChipsArr && _this.persistentChipsArr.length > 0) {
                        // const uniqueChipList = this.persistentChipsArr.filter((e, i) => {
                        //     return this.persistentChipsArr.findIndex((x) => {
                        //         return x.criteriaId === e.criteriaId;
                        //     }) === i;
                        // });
                        _this.persistentChipsArr.forEach(function (value) {
                            if (value.criteriaType === 'CALENDAR' && typeof value.optionParams.data[0].value !== 'string') {
                                value.optionParams.data[0].value = moment(value.optionParams.data[0].value).format('YYYY-MM-DD');
                            }
                        });
                        _this.chipInputService.persistChips(_this.persistentChipsArr);
                        // trigger search when chips persisting
                        _this.isDataLoaded = false;
                        // this.isTriggerSearch = false;
                        _this.onGenReservationSearch(_this.genReservationSearchCriteria);
                    }
                }
                _this.chipInputService.criteriaUpdate.subscribe(function (_data) {
                    _this.genReservationSearchCriteria = _data;
                });
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.onGenReservationSearch = function (event) {
        var _this = this;
        this.isDataLoaded = false;
        this.isDataLoaded = true; //todo remove
        this.genReservationSearchCriteria = event;
        this.userJourneyManager.canProceed.next(false);
        if (this.tPagination && this.tPagination['initialFetchingPages'] && this.tPagination['defaultPageResultCount']) {
            this.genReservationSearchCriteria.size = this.tPagination['initialFetchingPages'] * this.tPagination['defaultPageResultCount'];
            this.genReservationSearchCriteria.start = 0;
        }
        this.userJourneyManager.disableQuickActions([
            'TRIGGER_EXPORT_FILE'
        ]);
        this.genReservationSearchCriteria = event;
        if (!this.genReservationSearchCriteria.groupBy) {
            this.genReservationSearchCriteria.sortDirection = SortDirection.ASC;
        }
        if (JSON.stringify(this.genReservationSearchCriteria) !== JSON.stringify({})) {
            this.dataStoreService.set(DataKey.genReservationSearchCriteria, this.genReservationSearchCriteria, true);
            this.dataStoreService.set(DataKey.genReservationSearchResultsFromService, null, true);
            // set criteria parameters to url
            var queryParams = [];
            queryParams = this.queryParamService.getQueryParamsArray(this.genReservationSearchCriteria);
            queryParams = queryParams.filter(function (val) { return val !== 'page'; });
            this.rootService.setDataToLocalStorage(TCO.AppData.GEN_RESERVATION_SEARCH_CRITERIA, this.genReservationSearchCriteria, true, queryParams, true);
            // remove grid sorting and filtering
            this.genReservationSearchCriteria.gridFiltering = undefined;
            this.genReservationSearchCriteria.gridSorting = "[{'colId':'serviceDate','sort':'asc'},{'colId':'tourItemName','sort':'asc'},{'colId':'assignmentId','sort':'asc'}]";
            // search data //todo remove comment
            this.genReservationManagementService.searchReservations(this.genReservationSearchCriteria);
            // this.spinnerService.show();
            //this.isDataLoaded = false;  //todo remove comment
            this.isTriggerSearch = false;
            this.searchTrigger.emit(true);
        }
        else {
            setTimeout(function () {
                _this.isDataLoaded = true;
                _this.isTriggerSearch = true;
            }, 0);
        }
    };
    GenReservationSearchCriteriaComponent.prototype.getUpdatedFieldsDataObject = function (chip, criteria) {
        var dataObjArr = [];
        if (chip && chip.dataParams && chip.dataParams.length > 0) {
            chip.dataParams.forEach(function (dataParam) {
                var dataObj = {
                    key: '',
                    value: ''
                };
                dataObj.key = dataParam.paramValue;
                dataObj.value = criteria[dataParam.paramValue];
                dataObjArr.push(dataObj);
            });
        }
        return dataObjArr;
    };
    GenReservationSearchCriteriaComponent.prototype.getGenReservationSearchObserver = function () {
        var _this = this;
        var subscription = this.dataStoreService.get(DataKey.genReservationSearchResultsFromService)
            .subscribe(function (data) {
            if (_this.commonHelper.dataValidity(data)) {
                setTimeout(function () {
                    _this.isDataLoaded = true;
                    _this.isTriggerSearch = true;
                }, 0);
            }
            else if (_this.commonHelper.isEmptyData(data)) {
                _this.isDataLoaded = true;
            }
            else if (data instanceof TcApiError) {
                _this.isDataLoaded = true;
            }
            else if (data instanceof TcHttpError) {
                _this.isDataLoaded = true;
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.errorObserver = function () {
        var _this = this;
        this.dataStoreService.get(DataKey.error).subscribe(function (data) {
            if (data && JSON.stringify(data) !== JSON.stringify({})) {
                setTimeout(function () {
                    _this.isDataLoaded = true;
                }, 0);
                _this.dataStoreService.set(DataKey.error, null);
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.resetQueryParams = function () {
        var reservationQueryParams = [];
        reservationQueryParams = this.queryParamService.getQueryParamsArray(new ReservationSearchCriteria());
        var reservationSearchCriteria1 = this.rootService.loadDataFromLocalStorage(reservationQueryParams, new ReservationSearchCriteria(), TCO.AppData.GEN_RESERVATION_SEARCH_CRITERIA);
        // set criteria parameters to url
        var queryParams = [];
        queryParams = this.queryParamService.getQueryParamsArray(reservationSearchCriteria1);
        this.rootService.setDataToLocalStorage(TCO.AppData.GEN_RESERVATION_SEARCH_CRITERIA, this.genReservationSearchCriteria, true, queryParams, true);
    };
    GenReservationSearchCriteriaComponent.prototype.onCancel = function (event) {
        console.log('cancelled');
    };
    GenReservationSearchCriteriaComponent.prototype.onChipListDisplay = function (event) {
        this.dataStoreService.set(DataKey.chipListDisplay, null, true);
        this.isChipListDisplay = event;
        this.dataStoreService.set(DataKey.chipListDisplay, this.isChipListDisplay, true);
    };
    GenReservationSearchCriteriaComponent.prototype.handleQuickActions = function () {
        var _this = this;
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'TRIGGER_SEARCH_CRITERIA').subscribe(function (e) {
            _this.triggerSearch(e.data);
        });
    };
    GenReservationSearchCriteriaComponent.prototype.triggerSearch = function (data) {
        this.genReservationSearchCriteria = new ReservationSearchCriteria();
        this.genReservationSearchCriteria.serviceType = this.SERVICE_TYPE;
        this.genReservationSearchCriteria.productCode = '';
        this.genReservationSearchCriteria.startDate = '';
        this.genReservationSearchCriteria.endDate = '';
        this.actionHandlerService.fillCriteriaByActionData(data, this.genReservationSearchCriteria);
        var requiredChips = this.chipHandler.getChipsFromCriteria(this.genReservationSearchCriteria, TCO.CONF.CONF_GEN_RESERVATION_SEARCH_CRITERIA_CHIP, true);
        // requiredChips = this.chipHandler.validateAndFilterChips(requiredChips, ['bookingRefId|>|0']);
        this.chipInputService.hardReset();
        this.chipInputService.persistChips(requiredChips, true);
        // this.chipInputService.criteria = this.reservationSearchCriteria;
        this.onGenReservationSearch(this.genReservationSearchCriteria);
    };
    GenReservationSearchCriteriaComponent.prototype.handleInterRelatedChips = function () {
        var _this = this;
        this.relatedChipsObsv = this.chipInputService.relatedChipsSubject.subscribe(function (data) {
            var toggleChips = [];
            if (data && data.chip && JSON.stringify(data) !== JSON.stringify({})) {
                _this.modifiedChip = data.chip;
                // TODO: refine chip input service: inter related chips
                if (data.chip.type === 'CALENDAR') {
                    // startDate & returnDate validate
                    if (data.chip.id === 'START_DATE') {
                        var startDate = data.date;
                        var nights = 2;
                        var currentEndDate = _this.checkDependentForCalculateRelatedDate(data.chip);
                        if (currentEndDate) {
                            _this.setMinDateForRelatedDateChips(data.chip, data.date);
                            if (_this.dateFormatter.isAfter(startDate, currentEndDate)) {
                                _this.chipHandler.handleInterRelatedChips(data.chip, _this.dateFormatter.addDaysToDate(startDate, nights));
                            }
                            else {
                                _this.chipHandler.handleInterRelatedChips(data.chip, currentEndDate);
                            }
                        }
                    }
                }
                else {
                    _this.chipHandler.handleInterRelatedChips(data.chip, data.options.value[0]);
                }
                if (data.chip.optionParams.toggleChips && data.chip.optionParams.toggleChips.length > 0) {
                    toggleChips = data.chip.optionParams.toggleChips;
                    if (toggleChips && data.options && data.options.value[0].value) {
                        _this.chipInputService.selectedChipsBasedOnStateChange(toggleChips);
                    }
                    else {
                        _this.chipInputService.deleteChipsBasedOnStateChange(toggleChips);
                    }
                }
            }
        });
        this.relatedChipsProcessObsv = this.chipHandler.relatedChipsProcessSubject.subscribe(function (result) {
            if (result && JSON.stringify(result) !== JSON.stringify([]) && _this.modifiedChip.optionParams.relatedChips &&
                _this.modifiedChip.optionParams.relatedChips.length > 0 &&
                result.length === _this.modifiedChip.optionParams.relatedChips.length) {
                // if chip date is passed date it will be reset for today
                result.forEach(function (chip) {
                    if (chip.dataParam === 'DATE' && chip.criteriaId === 'START_DATE') {
                        chip.options = _this.dateFormatter.dateFromString(chip.options) > _this.dateFormatter.getToday() ?
                            chip.options :
                            _this.dateFormatter.dateAsString(_this.dateFormatter.getToday());
                    }
                    if (chip.dataParam === 'DATE' && chip.criteriaId === 'END_DATE') {
                        chip.options = _this.dateFormatter.dateFromString(chip.options) > _this.dateFormatter.getToday() ?
                            chip.options :
                            _this.dateFormatter.dateAsString(_this.dateFormatter.getToday());
                    }
                });
                // pass related chips to chip input service
                _this.chipInputService.handleInterRelatedChips(result);
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.setMinDateForRelatedDateChips = function (chip, date) {
        if (date && chip && chip.optionParams && chip.optionParams.relatedChips) {
            var minDate_1 = this.dateFormatter.dateFromString(date);
            chip.optionParams.relatedChips.forEach(function (relateChip) {
                if (relateChip.criteriaType === 'CALENDAR') {
                    relateChip.data = [{
                            key: 'minDate',
                            value: minDate_1
                        }];
                }
            });
        }
    };
    /**
     * Check dependent if available when calculate related date or related duration
     * @param chip Chip
     */
    GenReservationSearchCriteriaComponent.prototype.checkDependentForCalculateRelatedDate = function (chip) {
        var dateParam;
        if (chip.optionParams && chip.optionParams.relatedChips) {
            var dependent = chip.optionParams.behaviouralData.find(function (behData) { return behData.key === 'DATE_RELATED_DEPENDENT'; });
            if (dependent) {
                dateParam = this.getValueOfDependentParameter(dependent.value);
            }
        }
        return dateParam;
    };
    /**
     * Read additional params for handle inter related chips
     * @param dependent Dependent
     */
    GenReservationSearchCriteriaComponent.prototype.getValueOfDependentParameter = function (dependent) {
        if (this.chipInputService && this.chipInputService.criteria && this.chipInputService.criteria[dependent.paramValue]) {
            return this.chipInputService.criteria[dependent.paramValue];
        }
        return '';
    };
    GenReservationSearchCriteriaComponent.prototype.ngOnDestroy = function () {
        // this.routerChangeSubscription.unsubscribe();
        this.userJourneyManager.routeChanges.next(false);
        if (this.selectedChipsObsv) {
            this.selectedChipsObsv.unsubscribe();
        }
        if (this.selectedFieldsObsv) {
            this.selectedFieldsObsv.unsubscribe();
        }
        if (this.chipValueUpdateSub) {
            this.chipValueUpdateSub.unsubscribe();
        }
        if (this.criteriaUpdateSubscription) {
            this.criteriaUpdateSubscription.unsubscribe();
        }
        if (this.deletedChipObsv) {
            this.deletedChipObsv.unsubscribe();
        }
        this.em.removeEvents([
            'TRIGGER_SEARCH_CRITERIA'
        ]);
    };
    GenReservationSearchCriteriaComponent.prototype.selectedChipsUpdate = function () {
        var _this = this;
        this.criteriaUpdateSubscription = this.chipInputService.selectedChipsSubject.subscribe(function (selectedChips) {
            var e_1, _a;
            _this.selectedChips = selectedChips;
            if (selectedChips && JSON.stringify(selectedChips) !== JSON.stringify([])) {
                try {
                    // toggle chips when selecting BRANCH_OF_CLIENT_ID chip
                    for (var _b = tslib_1.__values(_this.selectedChips), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var selectedChip = _c.value;
                        if (selectedChip.chip.id === 'BRANCH_OF_CLIENT_ID' && selectedChip.chip.optionParams.toggleChips &&
                            selectedChip.chip.optionParams.toggleChips.length > 0) {
                            _this.deleteToggleChips(selectedChip.chip.optionParams.toggleChips);
                            _this.disableChips(selectedChip.chip.optionParams.toggleChips);
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.notifyChipDelete = function () {
        var _this = this;
        this.deletedChipObsv = this.chipInputService.deletedChipsSubject.subscribe(function (deletedChip) {
            if (JSON.stringify(deletedChip) !== JSON.stringify({}) && deletedChip !== null && deletedChip !== undefined) {
                if (deletedChip.id === 'CLIENT_TYPE') {
                    var deleteChips = _this.selectedChips.map(function (chip) { return chip.chip; });
                    _this.deleteSelectedChips(deleteChips);
                    _this.enableChips(_this.availableChips);
                }
                else if (deletedChip.id === 'BRANCH_OF_CLIENT_ID') {
                    if (deletedChip.optionParams.toggleChips && deletedChip.optionParams.toggleChips.length > 0) {
                        _this.enableChips(deletedChip.optionParams.toggleChips);
                    }
                }
            }
        });
    };
    /**
     * Delete toggle chips if already selected
     *
     * @param toggleChips
     */
    GenReservationSearchCriteriaComponent.prototype.deleteToggleChips = function (toggleChips) {
        var _this = this;
        var deleteChips = [];
        toggleChips.forEach(function (toggleChip) {
            var e_2, _a;
            try {
                for (var _b = tslib_1.__values(_this.selectedChips), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var selectedChip = _c.value;
                    if (selectedChip.chip.id === toggleChip.criteriaId) {
                        deleteChips.push(selectedChip.chip);
                        break;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
        this.deleteSelectedChips(deleteChips);
    };
    GenReservationSearchCriteriaComponent.prototype.deleteSelectedChips = function (deleteChips) {
        var _this = this;
        deleteChips.forEach(function (chip) {
            _this.chipInputService.deleteChip(chip, true);
        });
    };
    GenReservationSearchCriteriaComponent.prototype.enableChips = function (enableChips) {
        var _this = this;
        enableChips.forEach(function (enableChip) {
            _this.chipInputService.modifyChipsStatus(enableChip, false);
        });
    };
    GenReservationSearchCriteriaComponent.prototype.disableChips = function (disableChips) {
        var _this = this;
        disableChips.forEach(function (disableChip) {
            _this.chipInputService.modifyChipsStatus(disableChip, true);
        });
    };
    GenReservationSearchCriteriaComponent.prototype.searchFromSavedCriteriaObserver = function () {
        var _this = this;
        this.isChipsInit = false;
        var x = this.dataStoreService.get(DataKey.searchFromSavedCriteria).subscribe(function (data) {
            if (_this.commonHelper.dataValidity(data) && !_this.isChipsInit) {
                var criteriaStartDate = _this.genReservationSearchCriteria.startDate;
                var criteriaEndDate = _this.genReservationSearchCriteria.endDate;
                _this.genReservationSearchCriteria = data;
                _this.genReservationSearchCriteria.startDate = criteriaStartDate;
                _this.genReservationSearchCriteria.endDate = criteriaEndDate;
                _this.genReservationSearchCriteria.serviceType = _this.SERVICE_TYPE;
                if (_this.genReservationSearchCriteria && _this.genReservationSearchCriteria.startDate && _this.genReservationSearchCriteria.daysFrom) {
                    _this.genReservationSearchCriteria.startDate = new Date(+new Date() + _this.genReservationSearchCriteria.daysFrom * 86400000).toISOString().split('T')[0];
                    _this.genReservationSearchCriteria.endDate = new Date(+new Date(_this.genReservationSearchCriteria.startDate) + 172800000).toISOString().split('T')[0];
                }
                else if (_this.genReservationSearchCriteria && !_this.genReservationSearchCriteria.startDate) {
                    _this.genReservationSearchCriteria.startDate = new Date().toISOString().split('T')[0];
                    _this.genReservationSearchCriteria.endDate = new Date(+new Date() + 172800000).toISOString().split('T')[0];
                }
                var queryParams = [];
                queryParams.forEach(function (param) {
                    _this.queryParamService.deleteQueryParam(param);
                });
                queryParams = _this.queryParamService.getQueryParamsArray(_this.genReservationSearchCriteria);
                queryParams = queryParams.filter(function (val) { return val !== 'page'; });
                _this.rootService.setDataToLocalStorage(TCO.AppData.GEN_RESERVATION_SEARCH_CRITERIA, _this.genReservationSearchCriteria, true, queryParams, true);
                /*let qparams: Map<string, any> = new Map();
                 let criteriaObj = this.reservationSearchCriteria;
                 for (let key in criteriaObj) {
                 if(criteriaObj[key] && criteriaObj[key] !== 'page' ){
                 qparams.set(key, criteriaObj[key]);
                 }
                 }*/
                _this.displayChipsArr = [];
                _this.persistentChipsArr = [];
                _this.persistentQParamMap = new Map();
                if (_this.genReservationSearchCriteria) {
                    _this.persistentQParams = [];
                    _this.persistentQParams = _this.queryParamService.getNotNullQueryParamsArray(_this.genReservationSearchCriteria);
                }
                if (!_this.isChipsInit) {
                    _this.initSearchCriteriaChips(); // load everything from start
                }
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.onShowSavedCriteriaClick = function () {
        var _this = this;
        this.dataStoreService.set(DataKey.searchFromSavedCriteria, null);
        this.dataStoreService.set(DataKey.popupClose, null);
        var dataObject = new ModalData(LEVEL.SUCCESS, 'Show Criteria', null, null, 'modal-basic--alt modal-basic--fixed-size', ShowSavedCriteriaModalComponent, {
            'userDefinedCriteriaList': this.userDefinedCriteriaList,
            'systemDefinedCriteriaList': this.systemDefinedCriteriaList
        });
        var secondaryHeader = '';
        dataObject.secondaryHeader = secondaryHeader;
        this.confirmModal(dataObject);
        this.searchFromSavedCriteriaObserver();
        this.dataStoreService.get(DataKey.popupClose).subscribe(function (data) {
            if (data != null) {
                _this.closeModal();
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.closeModal = function () {
        if (this.modalService.close()) {
            this.modalService.close().subscribe(function (res) {
            });
        }
    };
    GenReservationSearchCriteriaComponent.prototype.confirmModal = function (data) {
        this.modalService.confirm(data).subscribe(function (res) {
        });
    };
    GenReservationSearchCriteriaComponent.prototype.getUserDefinedCriteriaList = function () {
        var _this = this;
        this.dataStoreService.get(DataKey.userSavedSearchCriteriaList).subscribe(function (data) {
            if (data) {
                _this.userDefinedCriteriaList = data;
            }
        });
    };
    GenReservationSearchCriteriaComponent.prototype.getSystemDefinedCriteriaList = function () {
        var _this = this;
        this.dataStoreService.get(DataKey.systemDefinedCriteria).subscribe(function (data) {
            if (data) {
                _this.systemDefinedCriteriaList = data;
            }
        });
    };
    return GenReservationSearchCriteriaComponent;
}());
export { GenReservationSearchCriteriaComponent };
